import { render } from "./SongCom.vue?vue&type=template&id=9c427af2&scoped=true"
import script from "./SongCom.vue?vue&type=script&lang=js"
export * from "./SongCom.vue?vue&type=script&lang=js"

import "./SongCom.vue?vue&type=style&index=0&id=9c427af2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c427af2"]])

export default __exports__